import './Projects.css';

const projects = [
  {
    title: 'Stretch Atlas',
    desc: 'A mobile app featuring an interactive anatomical body map that guides athletes and bodybuilders through targeted stretches based on what\'s sore. Tap a muscle group, get the stretch.',
    image: '/stretch_atlas.png',
    tags: ['React Native', 'Mobile', 'iOS', 'Android'],
  },
  {
    title: 'Coaching Platform',
    desc: 'A coaching and fitness platform I built for a client. Currently under NDA, so can\'t share the details, but it\'s a good one.',
    image: '/coaching.jpg',
    tags: ['React Native', 'Mobile', 'iOS', 'Tablet', 'Android', 'Web', 'Stripe', 'Appwrite'],
  },
  {
    title: 'Made With Love',
    desc: 'A mobile food delivery app connecting home cooks with local food lovers. Think Uber Eats but for your grandma\'s home-cooked meals.',
    image: '/made_with_love.jpg',
    tags: ['Mobile', 'iOS', 'Android', 'Supabase', 'Stripe'],
  },
];

export default function Projects() {
  return (
    <div className="projects-page">
      <section className="projects-hero">
        <h1 className="projects-heading">
          Things I've <span className="accent-pink">Built</span>
        </h1>
        <p className="projects-subheading">
          Side projects, client work, and your next big idea?
        </p>
      </section>

      <section className="projects-grid-section">
        <div className="projects-grid">
          {projects.map(({ title, desc, image, tags }) => (
            <div key={title} className="project-card">
              <div className="project-card-image-wrap">
                <img src={image} alt={title} className="project-card-image" />
              </div>
              <div className="project-card-body">
                <h3 className="project-card-title">{title}</h3>
                <p className="project-card-desc">{desc}</p>
                <div className="project-card-tags">
                  {tags.map((tag) => (
                    <span key={tag} className="btn-glass glass project-tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
}
